import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';

import spacing from '@decisiv/design-tokens/lib/spacing';

import Flex from '@decisiv/ui-components/lib/components/Flex';

export const SummaryRow = styled(Flex).attrs({
  marginTop: 1,
  alignItems: 'center',
  justifyContent: 'space-between',
})`
  gap: ${rem(spacing.base)};
`;

export const StatusMessage = styled(Flex).attrs({
  flexDirection: 'column',
  marginLeft: 0.5,
})`
  row-gap: ${rem(spacing.base * 0.25)};
`;
